// src/pages/subjects/tutor/SubjectTutorContent.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import "katex/dist/katex.min.css";

import "../../../styles/SubjectRightVar1.css";
import "../../../styles/SubjectTutor.css";
import "../../../styles/LessonContentTypography.css";

import {
  ALTKLAUSUREN_QUERY,
  CREATE_ALTKLAUSUR_MUTATION,
  CREATE_ALTKLAUSUR_QUIZ_OPTION_MUTATION,
  CREATE_ALTKLAUSUR_QUIZ_QUESTION_MUTATION,
  CREATE_ALTKLAUSUR_TASK_MUTATION,
  CREATE_ALTKLAUSUR_VERSION_MUTATION,
  CREATE_LESSON_CONTENT_MUTATION,
  CREATE_LESSON_TASK_MUTATION,
  CREATE_QUIZ_MUTATION,
  CREATE_QUIZ_OPTION_MUTATION,
  CREATE_SUBJECT_DETAIL_BLOCK_MUTATION,
  DELETE_ALTKLAUSUR_QUIZ_OPTION_MUTATION,
  DELETE_ALTKLAUSUR_QUIZ_QUESTION_MUTATION,
  DELETE_ALTKLAUSUR_TASK_MUTATION,
  DELETE_LESSON_CONTENT_MUTATION,
  DELETE_LESSON_TASK_MUTATION,
  DELETE_QUIZ_MUTATION,
  DELETE_QUIZ_OPTION_MUTATION,
  DELETE_SUBJECT_DETAIL_BLOCK_MUTATION,
  LESSON_CONTENTS_QUERY,
  LESSON_QUIZZES_QUERY,
  LESSON_TASKS_QUERY,
  SUBJECT_DETAIL_BLOCKS_QUERY,
  SUBJECT_QUERY,
  UPDATE_ALTKLAUSUR_MUTATION,
  UPDATE_ALTKLAUSUR_QUIZ_OPTION_MUTATION,
  UPDATE_ALTKLAUSUR_QUIZ_QUESTION_MUTATION,
  UPDATE_ALTKLAUSUR_TASK_MUTATION,
  UPDATE_ALTKLAUSUR_VERSION_MUTATION,
  UPDATE_LESSON_CONTENT_MUTATION,
  UPDATE_LESSON_TASK_MUTATION,
  UPDATE_QUIZ_MUTATION,
  UPDATE_QUIZ_OPTION_MUTATION,
  UPDATE_SUBJECT_DETAIL_BLOCK_MUTATION,
} from "./tutorSubjectGraphql";
import {
  DotsButton5,
  Menu5,
  TypeChooser5,
  buildAltklausurQuestionInput5,
  buildAltklausurTaskInput5,
  buildInternalAltVersionInput5,
  buildQuizInput5,
  buildTaskInput5,
  getAltContentCounts5,
  getCreateSubjectBlockPositions,
  getPrimaryAltVersion5,
  maxPosPlusOne,
  normalizeAltklausurQuizSourceType5,
  normalizeDifficulty5,
  normalizeQuizType5,
  sortPos,
  toLessonQuizQuestionType5,
} from "./tutorSubjectHelpers";
import {
  WEEKLY_PROFESSOR_QUIZ_ALTKLAUSUR_ID,
  getAltKlausurenPracticeLabel,
  getWeeklyProfessorQuizSlot,
  isWeeklyProfessorQuizSubject,
  orderWeeklyProfessorQuestions,
} from "../exceptions/subjectExceptions";
import {
  AltklausurMetaModal5,
  AltklausurQuizEditorModal5,
  DiscardChangesModal6,
  QuizEditorModal5,
  QuizOptionSummary5,
  TaskEditorModal5,
} from "./TutorSubjectModals";

import TutorNewIcon from "../../../Logos To be used/Dashboard Tutor New 2.svg";

import TextEditor from "../../components/TextEditor";
import { installSavedFormulaRenderer } from "../../../utils/renderSavedFormulas";
import { normalizeRichHtmlForDisplay } from "../../../utils/richContent";
import {
  getDeletedLessonContentIds,
  rememberDeletedLessonContentId,
} from "../../../utils/lessonContentVisibility";

/* ---------------- MAIN ---------------- */

export default function SubjectTutorR({
  subjectId,
  lessonId,
  lessonTitle,
  leftWidth = 300,
  showAltKlausurenEditor = false,
}) {
  const [hoverId5, setHoverId5] = useState(null);
  const [openMenu5, setOpenMenu5] = useState(null); // { kind: "subject"|"lesson", id }
  const hideTimerRef = useRef(null);

  const [, setChooserOpen5] = useState(false);

  const blockRefs5 = useRef(new Map());
  const contentRefs5 = useRef(new Map());
  const quizRefs5 = useRef(new Map());
  const taskRefs5 = useRef(new Map());
  const altQuizRefs5 = useRef(new Map());
  const altTaskRefs5 = useRef(new Map());
  const contentRootRef5 = useRef(null);

  // ---- editor state (shared for subject blocks + lesson text) ----
  const [editorOpen6, setEditorOpen6] = useState(false);
  const [editorKind6, setEditorKind6] = useState(null); // "subjectBlock" | "lessonText"
  const [editorMode6, setEditorMode6] = useState(null); // "create" | "edit"
  const [editorTargetId6, setEditorTargetId6] = useState(null); // blockId/contentId when edit
  const [editorInitialHtml6, setEditorInitialHtml6] = useState("");
  const [editorDirty6, setEditorDirty6] = useState(false);
  const [hiddenLessonContentIds, setHiddenLessonContentIds] = useState([]);
  const [quizModal5, setQuizModal5] = useState({ open: false, mode: "create", quiz: null });
  const [taskModal5, setTaskModal5] = useState({ open: false, mode: "create", task: null });
  const [altMetaModal5, setAltMetaModal5] = useState({
    open: false,
    kind: "exam",
    mode: "create",
    item: null,
  });
  const [altQuizModal5, setAltQuizModal5] = useState({
    open: false,
    mode: "create",
    question: null,
  });
  const [altTaskModal5, setAltTaskModal5] = useState({
    open: false,
    mode: "create",
    task: null,
  });
  const [quizSaving5, setQuizSaving5] = useState(false);
  const [taskSaving5, setTaskSaving5] = useState(false);
  const [altSaving5, setAltSaving5] = useState(false);
  const [altSelectedId5, setAltSelectedId5] = useState(null);
  const [altSelectedVersionId5, setAltSelectedVersionId5] = useState(null);
  const [altContentEditingId5, setAltContentEditingId5] = useState(null);
  const [altEditorTab5, setAltEditorTab5] = useState("aufgaben");
  const [altError5, setAltError5] = useState("");

  // pending action when dirty and user tries to do something else
  const [discardModalOpen6, setDiscardModalOpen6] = useState(false);
  const pendingActionRef6 = useRef(null); // () => void
  const isWeeklyProfessorException5 = isWeeklyProfessorQuizSubject(subjectId);
  const altKlausurenEditorTitle5 = getAltKlausurenPracticeLabel(subjectId);
  const altLockedMessage5 = isWeeklyProfessorException5
    ? "Dieses Wochenquiz ist gesperrt. Inhalte können nicht geändert werden."
    : "Diese Altklausur ist gesperrt. Inhalte können nicht geändert werden.";

  const clearHideTimer = () => {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    hideTimerRef.current = null;
  };

  const showDots = (id) => {
    clearHideTimer();
    setHoverId5(id);
  };

  const scheduleHideDots = (id) => {
    clearHideTimer();
    hideTimerRef.current = setTimeout(() => {
      if (!(openMenu5 && openMenu5.id === id)) {
        setHoverId5((prev) => (prev === id ? null : prev));
      }
    }, 3000);
  };

  // close menus when clicking outside (but keep editor)
  useEffect(() => {
    const onDown = (e) => {
      const menus = document.querySelectorAll(".tutorR-menu5");
      const dots = document.querySelectorAll(".tutorR-dots5.is-open5");
      const chooser = document.querySelectorAll(".tutorR-typeChooser5");

      const inMenu = Array.from(menus).some((m) => m.contains(e.target));
      const inDots = Array.from(dots).some((d) => d.contains(e.target));
      const inChooser = Array.from(chooser).some((c) => c.contains(e.target));

      if (!inMenu && !inDots && !inChooser) {
        setOpenMenu5(null);
        setChooserOpen5(false);
      }
    };

    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [openMenu5]);

  // If lesson changes while editing and dirty -> block (show modal)
  useEffect(() => {
    if (!editorOpen6) return;

    // whenever lessonId/subjectId changes from parent selection
    // we cannot prevent navigation here reliably, but we can at least close editor safely when not dirty
    if (!editorDirty6) {
      setEditorOpen6(false);
      setEditorKind6(null);
      setEditorMode6(null);
      setEditorTargetId6(null);
      setEditorInitialHtml6("");
    } else {
      // show discard modal (user clicked another lesson / route changed)
      setDiscardModalOpen6(true);
      pendingActionRef6.current = () => {
        setEditorOpen6(false);
        setEditorKind6(null);
        setEditorMode6(null);
        setEditorTargetId6(null);
        setEditorInitialHtml6("");
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonId, subjectId]);

  const { data: subjData } = useQuery(SUBJECT_QUERY, {
    variables: { id: subjectId },
    skip: !subjectId,
    fetchPolicy: "network-only",
  });

  const { data: blocksData, loading: blocksLoading, error: blocksError, refetch: refetchBlocks } = useQuery(
    SUBJECT_DETAIL_BLOCKS_QUERY,
    {
      variables: { subjectId },
      skip: !subjectId || Boolean(lessonId) || showAltKlausurenEditor,
      fetchPolicy: "network-only",
    }
  );

  const { data: contentsData, loading: contentsLoading, error: contentsError, refetch: refetchContents } = useQuery(
    LESSON_CONTENTS_QUERY,
    {
      variables: { lessonId },
      skip: !lessonId || showAltKlausurenEditor,
      fetchPolicy: "network-only",
    }
  );

  const { data: quizzesData, loading: quizzesLoading, error: quizzesError, refetch: refetchQuizzes } = useQuery(
    LESSON_QUIZZES_QUERY,
    {
      variables: { lessonId },
      skip: !lessonId || showAltKlausurenEditor,
      fetchPolicy: "network-only",
    }
  );

  const { data: tasksData, loading: tasksLoading, error: tasksError, refetch: refetchTasks } = useQuery(
    LESSON_TASKS_QUERY,
    {
      variables: { lessonID: lessonId },
      skip: !lessonId || showAltKlausurenEditor,
      fetchPolicy: "network-only",
    }
  );

  const {
    data: altData5,
    loading: altLoading5,
    error: altLoadError5,
    refetch: refetchAlt5,
  } = useQuery(ALTKLAUSUREN_QUERY, {
    variables: subjectId ? { subjectID: subjectId } : undefined,
    skip: !subjectId || !showAltKlausurenEditor,
    fetchPolicy: "network-only",
  });

  const [createSubjectDetailBlock] = useMutation(CREATE_SUBJECT_DETAIL_BLOCK_MUTATION);
  const [updateSubjectDetailBlock] = useMutation(UPDATE_SUBJECT_DETAIL_BLOCK_MUTATION);
  const [deleteSubjectDetailBlock] = useMutation(DELETE_SUBJECT_DETAIL_BLOCK_MUTATION);
  const [createLessonContent] = useMutation(CREATE_LESSON_CONTENT_MUTATION);
  const [updateLessonContent] = useMutation(UPDATE_LESSON_CONTENT_MUTATION);
  const [deleteLessonContent] = useMutation(DELETE_LESSON_CONTENT_MUTATION);
  const [createQuiz] = useMutation(CREATE_QUIZ_MUTATION);
  const [updateQuiz] = useMutation(UPDATE_QUIZ_MUTATION);
  const [deleteQuiz] = useMutation(DELETE_QUIZ_MUTATION);
  const [createQuizOption] = useMutation(CREATE_QUIZ_OPTION_MUTATION);
  const [updateQuizOption] = useMutation(UPDATE_QUIZ_OPTION_MUTATION);
  const [deleteQuizOption] = useMutation(DELETE_QUIZ_OPTION_MUTATION);
  const [createLessonTask] = useMutation(CREATE_LESSON_TASK_MUTATION);
  const [updateLessonTask] = useMutation(UPDATE_LESSON_TASK_MUTATION);
  const [deleteLessonTask] = useMutation(DELETE_LESSON_TASK_MUTATION);
  const [createAltklausur] = useMutation(CREATE_ALTKLAUSUR_MUTATION);
  const [updateAltklausur] = useMutation(UPDATE_ALTKLAUSUR_MUTATION);
  const [createAltklausurVersion] = useMutation(CREATE_ALTKLAUSUR_VERSION_MUTATION);
  const [updateAltklausurVersion] = useMutation(UPDATE_ALTKLAUSUR_VERSION_MUTATION);
  const [createAltklausurQuizQuestion] = useMutation(CREATE_ALTKLAUSUR_QUIZ_QUESTION_MUTATION);
  const [updateAltklausurQuizQuestion] = useMutation(UPDATE_ALTKLAUSUR_QUIZ_QUESTION_MUTATION);
  const [deleteAltklausurQuizQuestion] = useMutation(DELETE_ALTKLAUSUR_QUIZ_QUESTION_MUTATION);
  const [createAltklausurQuizOption] = useMutation(CREATE_ALTKLAUSUR_QUIZ_OPTION_MUTATION);
  const [updateAltklausurQuizOption] = useMutation(UPDATE_ALTKLAUSUR_QUIZ_OPTION_MUTATION);
  const [deleteAltklausurQuizOption] = useMutation(DELETE_ALTKLAUSUR_QUIZ_OPTION_MUTATION);
  const [createAltklausurTask] = useMutation(CREATE_ALTKLAUSUR_TASK_MUTATION);
  const [updateAltklausurTask] = useMutation(UPDATE_ALTKLAUSUR_TASK_MUTATION);
  const [deleteAltklausurTask] = useMutation(DELETE_ALTKLAUSUR_TASK_MUTATION);

  useEffect(() => {
    if (!lessonId) {
      setHiddenLessonContentIds([]);
      setQuizModal5({ open: false, mode: "create", quiz: null });
      setTaskModal5({ open: false, mode: "create", task: null });
      return;
    }
    setHiddenLessonContentIds(getDeletedLessonContentIds(lessonId));
    setQuizModal5({ open: false, mode: "create", quiz: null });
    setTaskModal5({ open: false, mode: "create", task: null });
  }, [lessonId]);

  const hiddenContentIdSet = useMemo(
    () => new Set(hiddenLessonContentIds),
    [hiddenLessonContentIds]
  );

  const serverSubjectBlocks = useMemo(() => (blocksData?.subjectDetailBlocks || []).slice().sort(sortPos), [blocksData]);
  const serverLessonContents = useMemo(
    () =>
      (contentsData?.lessonContentsByLesson || [])
        .filter((c) => !hiddenContentIdSet.has(c.id))
        .slice()
        .sort(sortPos),
    [contentsData, hiddenContentIdSet]
  );
  const serverLessonQuizzes = useMemo(
    () => (quizzesData?.quizzesByLesson || []).slice().sort(sortPos),
    [quizzesData]
  );
  const serverLessonTasks = useMemo(
    () => (tasksData?.lessonTasks || []).slice().sort(sortPos),
    [tasksData]
  );
  const altklausuren5 = useMemo(() => {
    return (altData5?.altklausuren || [])
      .slice()
      .sort((a, b) => String(a?.title || "").localeCompare(String(b?.title || "")))
      .map((alt) => {
        const primaryVersion = (alt?.versions || [])
          .slice()
          .sort((a, b) => {
            const dateA = a?.versionDate ? new Date(a.versionDate).getTime() : 0;
            const dateB = b?.versionDate ? new Date(b.versionDate).getTime() : 0;
            if (dateA !== dateB) return dateB - dateA;
            return String(a?.title || "").localeCompare(String(b?.title || ""));
          })
          .map((version) => ({
            ...version,
            quizQuestions: (version?.quizQuestions || []).slice().sort(sortPos),
            tasks: (version?.tasks || []).slice().sort(sortPos),
          }))[0];

        return {
          ...alt,
          versions: primaryVersion ? [primaryVersion] : [],
        };
      });
  }, [altData5]);

  const selectedAltklausur5 = useMemo(
    () => altklausuren5.find((alt) => alt.id === altSelectedId5) || altklausuren5[0] || null,
    [altSelectedId5, altklausuren5]
  );

  const selectedAltVersion5 = useMemo(() => {
    const versions = selectedAltklausur5?.versions || [];
    return versions.find((version) => version.id === altSelectedVersionId5) || versions[0] || null;
  }, [altSelectedVersionId5, selectedAltklausur5]);

  const selectedAltQuestions5 = useMemo(
    () => (selectedAltVersion5?.quizQuestions || []).slice().sort(sortPos),
    [selectedAltVersion5]
  );

  const selectedAltTasks5 = useMemo(
    () => (selectedAltVersion5?.tasks || []).slice().sort(sortPos),
    [selectedAltVersion5]
  );

  const weeklyProfessorAltklausur5 = useMemo(
    () =>
      altklausuren5.find(
        (alt) => String(alt?.id || "").toLowerCase() === WEEKLY_PROFESSOR_QUIZ_ALTKLAUSUR_ID
      ) || null,
    [altklausuren5]
  );

  const weeklyProfessorVersion5 = useMemo(
    () => (weeklyProfessorAltklausur5?.versions || [])[0] || null,
    [weeklyProfessorAltklausur5]
  );

  const weeklyProfessorQuestionSlots5 = useMemo(
    () => orderWeeklyProfessorQuestions(weeklyProfessorVersion5?.quizQuestions || []),
    [weeklyProfessorVersion5]
  );

  const [localSubjectBlocks5, setLocalSubjectBlocks5] = useState([]);
  const [localLessonContents5, setLocalLessonContents5] = useState([]);
  const [localLessonQuizzes5, setLocalLessonQuizzes5] = useState([]);
  const [localLessonTasks5, setLocalLessonTasks5] = useState([]);

  useEffect(() => setLocalSubjectBlocks5(serverSubjectBlocks), [serverSubjectBlocks]);
  useEffect(() => setLocalLessonContents5(serverLessonContents), [serverLessonContents]);
  useEffect(() => setLocalLessonQuizzes5(serverLessonQuizzes), [serverLessonQuizzes]);
  useEffect(() => setLocalLessonTasks5(serverLessonTasks), [serverLessonTasks]);

  useEffect(() => {
    if (!showAltKlausurenEditor) return;
    setEditorOpen6(false);
    setQuizModal5({ open: false, mode: "create", quiz: null });
    setTaskModal5({ open: false, mode: "create", task: null });
    setAltContentEditingId5(null);
    setOpenMenu5(null);
  }, [showAltKlausurenEditor]);

  useEffect(() => {
    if (!showAltKlausurenEditor) return;

    if (altklausuren5.length === 0) {
      setAltSelectedId5(null);
      setAltSelectedVersionId5(null);
      setAltContentEditingId5(null);
      return;
    }

    if (altContentEditingId5 && !altklausuren5.some((alt) => alt.id === altContentEditingId5)) {
      setAltContentEditingId5(null);
    }

    const nextAlt =
      altklausuren5.find((alt) => alt.id === altSelectedId5) ||
      (altContentEditingId5 ? altklausuren5.find((alt) => alt.id === altContentEditingId5) : null) ||
      altklausuren5[0];
    if (nextAlt?.id !== altSelectedId5) {
      setAltSelectedId5(nextAlt.id);
    }

    const versions = nextAlt?.versions || [];
    if (versions.length === 0) {
      setAltSelectedVersionId5(null);
      return;
    }

    const nextVersion =
      versions.find((version) => version.id === altSelectedVersionId5) || versions[0];
    if (nextVersion?.id !== altSelectedVersionId5) {
      setAltSelectedVersionId5(nextVersion.id);
    }
  }, [altContentEditingId5, altSelectedId5, altSelectedVersionId5, altklausuren5, showAltKlausurenEditor]);

  useEffect(() => {
    const root = contentRootRef5.current;
    if (!root) return;

    return installSavedFormulaRenderer(root);
  }, [
    lessonId,
    localSubjectBlocks5,
    localLessonContents5,
    localLessonQuizzes5,
    localLessonTasks5,
    selectedAltQuestions5,
    selectedAltTasks5,
    showAltKlausurenEditor,
  ]);

  const pageTitle = useMemo(() => {
    if (lessonId) return lessonTitle || "";
    return subjData?.subject?.title || "";
  }, [lessonId, lessonTitle, subjData]);

  const guardIfDirtyOrRun = (actionFn) => {
    if (editorOpen6 && editorDirty6) {
      setDiscardModalOpen6(true);
      pendingActionRef6.current = actionFn;
      return;
    }
    actionFn?.();
  };

  const openEditorCreateSubjectBlock6 = () => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setChooserOpen5(false);
      setEditorOpen6(true);
      setEditorKind6("subjectBlock");
      setEditorMode6("create");
      setEditorTargetId6(null);
      setEditorInitialHtml6("");
      setEditorDirty6(false);
    });
  };

  const openEditorEditSubjectBlock6 = (block) => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setChooserOpen5(false);
      setEditorOpen6(true);
      setEditorKind6("subjectBlock");
      setEditorMode6("edit");
      setEditorTargetId6(block.id);
      setEditorInitialHtml6(block.html || "");
      setEditorDirty6(false);
    });
  };

  const openEditorCreateLessonText6 = () => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setChooserOpen5(false);
      setEditorOpen6(true);
      setEditorKind6("lessonText");
      setEditorMode6("create");
      setEditorTargetId6(null);
      setEditorInitialHtml6("");
      setEditorDirty6(false);
    });
  };

  const openEditorEditLessonText6 = (content) => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setChooserOpen5(false);
      setEditorOpen6(true);
      setEditorKind6("lessonText");
      setEditorMode6("edit");
      setEditorTargetId6(content.id);
      setEditorInitialHtml6(content.contentData || "");
      setEditorDirty6(false);
    });
  };

  const openQuizCreate5 = () => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setQuizModal5({ open: true, mode: "create", quiz: null });
    });
  };

  const openQuizEdit5 = (quiz) => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setQuizModal5({ open: true, mode: "edit", quiz });
    });
  };

  const openTaskCreate5 = () => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setTaskModal5({ open: true, mode: "create", task: null });
    });
  };

  const openTaskEdit5 = (task) => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setTaskModal5({ open: true, mode: "edit", task });
    });
  };

  const openAltMetaCreate5 = (kind) => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setAltError5("");
      setAltMetaModal5({ open: true, kind, mode: "create", item: null });
    });
  };

  const openAltMetaEdit5 = (kind, item) => {
    guardIfDirtyOrRun(() => {
      setOpenMenu5(null);
      setAltError5("");
      setAltMetaModal5({ open: true, kind, mode: "edit", item });
    });
  };

  const openAltQuizCreate5 = () => {
    guardIfDirtyOrRun(async () => {
      const version = await ensureSingleAltVersion5();
      if (!version) return;
      if (version.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setOpenMenu5(null);
      setAltError5("");
      setAltQuizModal5({ open: true, mode: "create", question: null });
    });
  };

  const openAltQuizEdit5 = (question) => {
    guardIfDirtyOrRun(() => {
      if (selectedAltVersion5?.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setOpenMenu5(null);
      setAltError5("");
      setAltQuizModal5({ open: true, mode: "edit", question });
    });
  };

  const openWeeklyProfessorQuestionEdit5 = (question) => {
    guardIfDirtyOrRun(() => {
      if (!weeklyProfessorAltklausur5?.id || !weeklyProfessorVersion5?.id || !question?.id) {
        setAltError5("Das Wochenquiz konnte nicht vollständig geladen werden.");
        return;
      }
      if (weeklyProfessorVersion5.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setAltSelectedId5(weeklyProfessorAltklausur5.id);
      setAltSelectedVersionId5(weeklyProfessorVersion5.id);
      setAltContentEditingId5(weeklyProfessorAltklausur5.id);
      setOpenMenu5(null);
      setAltError5("");
      setAltQuizModal5({ open: true, mode: "edit", question });
    });
  };

  const openAltTaskCreate5 = () => {
    guardIfDirtyOrRun(async () => {
      const version = await ensureSingleAltVersion5();
      if (!version) return;
      if (version.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setOpenMenu5(null);
      setAltError5("");
      setAltTaskModal5({ open: true, mode: "create", task: null });
    });
  };

  const openAltTaskEdit5 = (task) => {
    guardIfDirtyOrRun(() => {
      if (selectedAltVersion5?.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setOpenMenu5(null);
      setAltError5("");
      setAltTaskModal5({ open: true, mode: "edit", task });
    });
  };

  const closeEditorRequest6 = () => {
    if (!editorOpen6) return;

    if (editorDirty6) {
      setDiscardModalOpen6(true);
      pendingActionRef6.current = () => {
        setEditorOpen6(false);
        setEditorKind6(null);
        setEditorMode6(null);
        setEditorTargetId6(null);
        setEditorInitialHtml6("");
        setEditorDirty6(false);
      };
      return;
    }

    setEditorOpen6(false);
    setEditorKind6(null);
    setEditorMode6(null);
    setEditorTargetId6(null);
    setEditorInitialHtml6("");
    setEditorDirty6(false);
  };

  const onDiscardYes6 = () => {
    setDiscardModalOpen6(false);
    const fn = pendingActionRef6.current;
    pendingActionRef6.current = null;
    fn?.();
  };

  const onDiscardNo6 = () => {
    setDiscardModalOpen6(false);
    pendingActionRef6.current = null;
  };

  // ---- FLIP animations (unchanged) ----
  const animateSwap5 = (beforeRects, refsMap) => {
    requestAnimationFrame(() => {
      const afterRects = new Map();
      beforeRects.forEach((_, id) => {
        const el = refsMap.get(id);
        if (!el) return;
        afterRects.set(id, el.getBoundingClientRect());
      });

      beforeRects.forEach((beforeRect, id) => {
        const afterRect = afterRects.get(id);
        const el = refsMap.get(id);
        if (!beforeRect || !afterRect || !el) return;

        const dx = beforeRect.left - afterRect.left;
        const dy = beforeRect.top - afterRect.top;
        if (dx === 0 && dy === 0) return;

        el.style.transform = `translate(${dx}px, ${dy}px)`;
        el.style.transition = "transform 0s";
        // eslint-disable-next-line no-unused-expressions
        el.offsetHeight;

        el.style.transition = "transform 820ms cubic-bezier(0.22, 1, 0.36, 1)";
        el.style.transform = "translate(0px, 0px)";

        const cleanup = () => {
          el.style.transition = "";
          el.style.transform = "";
          el.removeEventListener("transitionend", cleanup);
        };
        el.addEventListener("transitionend", cleanup);
      });
    });
  };

  const swapSubjectBlocks5 = async (indexA, indexB) => {
    guardIfDirtyOrRun(async () => {
      const list = localSubjectBlocks5;
      if (indexA < 0 || indexB < 0) return;
      if (indexA >= list.length || indexB >= list.length) return;

      const a = list[indexA];
      const b = list[indexB];
      if (!a?.id || !b?.id) return;

      const beforeRects = new Map();
      [a.id, b.id].forEach((id) => {
        const el = blockRefs5.current.get(id);
        if (el) beforeRects.set(id, el.getBoundingClientRect());
      });

      const next = list.slice();
      next[indexA] = b;
      next[indexB] = a;
      setLocalSubjectBlocks5(next);

      animateSwap5(beforeRects, blockRefs5.current);

      const posA = a.position ?? 0;
      const posB = b.position ?? 0;

      try {
        await updateSubjectDetailBlock({ variables: { input: { id: a.id, position: posB } } });
        await updateSubjectDetailBlock({ variables: { input: { id: b.id, position: posA } } });
        await refetchBlocks();
      } catch (e) {
        await refetchBlocks();
        setLocalSubjectBlocks5(serverSubjectBlocks);
      }
    });
  };

  const swapLessonContents5 = async (indexA, indexB) => {
    guardIfDirtyOrRun(async () => {
      const list = localLessonContents5;
      if (indexA < 0 || indexB < 0) return;
      if (indexA >= list.length || indexB >= list.length) return;

      const a = list[indexA];
      const b = list[indexB];
      if (!a?.id || !b?.id) return;

      const beforeRects = new Map();
      [a.id, b.id].forEach((id) => {
        const el = contentRefs5.current.get(id);
        if (el) beforeRects.set(id, el.getBoundingClientRect());
      });

      const next = list.slice();
      next[indexA] = b;
      next[indexB] = a;
      setLocalLessonContents5(next);

      animateSwap5(beforeRects, contentRefs5.current);

      const posA = a.position ?? 0;
      const posB = b.position ?? 0;

      try {
        await updateLessonContent({ variables: { input: { id: a.id, position: posB } } });
        await updateLessonContent({ variables: { input: { id: b.id, position: posA } } });
        await refetchContents();
      } catch (e) {
        await refetchContents();
        setLocalLessonContents5(serverLessonContents);
      }
    });
  };

  const toggleAI5 = async (content) => {
    guardIfDirtyOrRun(async () => {
      try {
        await updateLessonContent({
          variables: { input: { id: content.id, aiEnabled: !content.aiEnabled } },
        });
        await refetchContents();
      } catch (e) {
        await refetchContents();
      }
    });
  };

  const deleteSubjectBlock5 = async (block) => {
    guardIfDirtyOrRun(async () => {
      if (!block?.id) return;

      const previousBlocks = localSubjectBlocks5;
      const remainingBlocks = previousBlocks
        .filter((x) => x.id !== block.id)
        .slice()
        .sort(sortPos);
      setLocalSubjectBlocks5(remainingBlocks);
      setOpenMenu5(null);

      try {
        await deleteSubjectDetailBlock({ variables: { id: block.id } });

        if (remainingBlocks.length > 0) {
          const basePosition = previousBlocks.reduce((minPos, item) => {
            const parsed = Number(item?.position);
            if (!Number.isFinite(parsed)) return minPos;
            return Math.min(minPos, parsed);
          }, Number.MAX_SAFE_INTEGER);

          const safeBasePosition =
            basePosition === Number.MAX_SAFE_INTEGER ? 0 : basePosition;

          for (let i = 0; i < remainingBlocks.length; i += 1) {
            const item = remainingBlocks[i];
            const expectedPosition = safeBasePosition + i;
            const currentPosition = Number(item?.position);

            if (!Number.isFinite(currentPosition)) {
              // Ensure malformed positions are healed too.
              // eslint-disable-next-line no-await-in-loop
              await updateSubjectDetailBlock({
                variables: { input: { id: item.id, position: expectedPosition } },
              });
              continue;
            }

            if (currentPosition !== expectedPosition) {
              // eslint-disable-next-line no-await-in-loop
              await updateSubjectDetailBlock({
                variables: { input: { id: item.id, position: expectedPosition } },
              });
            }
          }
        }

        await refetchBlocks();
      } catch (e) {
        setLocalSubjectBlocks5(previousBlocks);
        await refetchBlocks();
      }
    });
  };

  const deleteLessonContent5 = async (content) => {
    guardIfDirtyOrRun(async () => {
      if (!lessonId || !content?.id) return;

      const previousContents = localLessonContents5;
      setLocalLessonContents5((prev) => prev.filter((x) => x.id !== content.id));
      setOpenMenu5(null);

      try {
        await deleteLessonContent({ variables: { id: content.id } });

        rememberDeletedLessonContentId(lessonId, content.id);
        setHiddenLessonContentIds((prev) =>
          prev.includes(content.id) ? prev : [...prev, content.id]
        );

        await refetchContents();
      } catch (e) {
        setLocalLessonContents5(previousContents);
        await refetchContents();
      }
    });
  };

  const swapQuizzes5 = async (indexA, indexB) => {
    guardIfDirtyOrRun(async () => {
      const list = localLessonQuizzes5;
      if (indexA < 0 || indexB < 0) return;
      if (indexA >= list.length || indexB >= list.length) return;

      const a = list[indexA];
      const b = list[indexB];
      if (!a?.id || !b?.id) return;

      const beforeRects = new Map();
      [a.id, b.id].forEach((id) => {
        const el = quizRefs5.current.get(id);
        if (el) beforeRects.set(id, el.getBoundingClientRect());
      });

      const next = list.slice();
      next[indexA] = b;
      next[indexB] = a;
      setLocalLessonQuizzes5(next);
      animateSwap5(beforeRects, quizRefs5.current);

      const posA = a.position ?? 0;
      const posB = b.position ?? 0;

      try {
        await updateQuiz({ variables: { input: buildQuizInput5(a, posB) } });
        await updateQuiz({ variables: { input: buildQuizInput5(b, posA) } });
        await refetchQuizzes();
      } catch (e) {
        await refetchQuizzes();
        setLocalLessonQuizzes5(serverLessonQuizzes);
      }
    });
  };

  const swapTasks5 = async (indexA, indexB) => {
    guardIfDirtyOrRun(async () => {
      const list = localLessonTasks5;
      if (indexA < 0 || indexB < 0) return;
      if (indexA >= list.length || indexB >= list.length) return;

      const a = list[indexA];
      const b = list[indexB];
      if (!a?.id || !b?.id) return;

      const beforeRects = new Map();
      [a.id, b.id].forEach((id) => {
        const el = taskRefs5.current.get(id);
        if (el) beforeRects.set(id, el.getBoundingClientRect());
      });

      const next = list.slice();
      next[indexA] = b;
      next[indexB] = a;
      setLocalLessonTasks5(next);
      animateSwap5(beforeRects, taskRefs5.current);

      const posA = a.position ?? 0;
      const posB = b.position ?? 0;

      try {
        await updateLessonTask({ variables: { input: { id: a.id, position: posB } } });
        await updateLessonTask({ variables: { input: { id: b.id, position: posA } } });
        await refetchTasks();
      } catch (e) {
        await refetchTasks();
        setLocalLessonTasks5(serverLessonTasks);
      }
    });
  };

  const deleteQuiz5 = async (quiz) => {
    guardIfDirtyOrRun(async () => {
      if (!quiz?.id) return;

      const previous = localLessonQuizzes5;
      setLocalLessonQuizzes5((prev) => prev.filter((item) => item.id !== quiz.id));
      setOpenMenu5(null);

      try {
        await deleteQuiz({ variables: { id: quiz.id } });
        await refetchQuizzes();
      } catch (e) {
        setLocalLessonQuizzes5(previous);
        await refetchQuizzes();
      }
    });
  };

  const deleteTask5 = async (task) => {
    guardIfDirtyOrRun(async () => {
      if (!task?.id) return;

      const previous = localLessonTasks5;
      setLocalLessonTasks5((prev) => prev.filter((item) => item.id !== task.id));
      setOpenMenu5(null);

      try {
        await deleteLessonTask({ variables: { id: task.id } });
        await refetchTasks();
      } catch (e) {
        setLocalLessonTasks5(previous);
        await refetchTasks();
      }
    });
  };

  const saveQuiz5 = async ({ mode, quiz, options, initialOptions }) => {
    if (!lessonId) return;

    setQuizSaving5(true);
    try {
      const quizType = normalizeQuizType5(quiz.questionType);
      const firstCorrectIndex = options.findIndex((opt) => opt.isCorrect);
      const normalizedOptions = options.map((opt, index) => ({
        ...opt,
        isCorrect:
          quizType === "single_choice"
            ? index === Math.max(firstCorrectIndex, 0)
            : !!opt.isCorrect,
        position: index,
      }));

      let quizId = quiz.id;
      const position = mode === "create" ? maxPosPlusOne(localLessonQuizzes5) : quiz.position ?? 0;

      if (mode === "create") {
        const created = await createQuiz({
          variables: {
            input: {
              lessonId,
              question: quiz.question,
              questionType: toLessonQuizQuestionType5(quizType),
              position,
              isKlausurRelevant: !!quiz.isKlausurRelevant,
              requiredForCompletion: quiz.requiredForCompletion !== false,
              difficulty: normalizeDifficulty5(quiz.difficulty),
              sourceType: quiz.sourceType || "manual",
              explanation: quiz.explanation || "",
              hint: quiz.hint || "",
            },
          },
        });
        quizId = created?.data?.createQuiz?.id;
      } else {
        await updateQuiz({
          variables: {
            input: buildQuizInput5(
              {
                ...quiz,
                questionType: quizType,
                difficulty: normalizeDifficulty5(quiz.difficulty),
              },
              position
            ),
          },
        });
      }

      if (!quizId) throw new Error("Quiz konnte nicht gespeichert werden.");

      const initialById = new Map((initialOptions || []).filter((opt) => opt.id).map((opt) => [opt.id, opt]));
      const nextIds = new Set();

      for (let i = 0; i < normalizedOptions.length; i += 1) {
        const opt = normalizedOptions[i];
        if (opt.id) {
          nextIds.add(opt.id);
          // eslint-disable-next-line no-await-in-loop
          await updateQuizOption({
            variables: {
              input: {
                id: opt.id,
                optionText: opt.optionText,
                isCorrect: !!opt.isCorrect,
                position: i,
              },
            },
          });
        } else {
          // eslint-disable-next-line no-await-in-loop
          await createQuizOption({
            variables: {
              input: {
                quizId,
                optionText: opt.optionText,
                isCorrect: !!opt.isCorrect,
                position: i,
              },
            },
          });
        }
      }

      for (const id of initialById.keys()) {
        if (nextIds.has(id)) continue;
        // eslint-disable-next-line no-await-in-loop
        await deleteQuizOption({ variables: { id } });
      }

      await refetchQuizzes();
      setQuizModal5({ open: false, mode: "create", quiz: null });
    } finally {
      setQuizSaving5(false);
    }
  };

  const saveTask5 = async ({ mode, task }) => {
    if (!lessonId) return;

    setTaskSaving5(true);
    try {
      if (mode === "create") {
        await createLessonTask({
          variables: {
            input: {
              lessonID: lessonId,
              title: task.title,
              taskText: task.taskText || "",
              hintText: task.hintText || "",
              answerText: task.answerText || "",
              position: maxPosPlusOne(localLessonTasks5),
              difficulty: normalizeDifficulty5(task.difficulty),
              estimatedMinutes: Math.max(0, Number(task.estimatedMinutes || 0)),
              isPublished: !!task.isPublished,
            },
          },
        });
      } else {
        await updateLessonTask({
          variables: {
            input: buildTaskInput5(task, task.position ?? 0),
          },
        });
      }

      await refetchTasks();
      setTaskModal5({ open: false, mode: "create", task: null });
    } finally {
      setTaskSaving5(false);
    }
  };

  const saveAltMeta5 = async ({ kind, mode, item }) => {
    if (!subjectId) return;

    setAltSaving5(true);
    setAltError5("");
    try {
      if (kind === "exam") {
        const altId = item.id || altMetaModal5.item?.id;
        const currentAlt =
          altklausuren5.find((alt) => alt.id === altId) || altMetaModal5.item || null;
        const existingVersion = getPrimaryAltVersion5(currentAlt);
        const input = {
          subjectID: subjectId,
          title: item.title,
          description: item.description || "",
          isPublished: !!item.isPublished,
        };

        const result =
          mode === "create"
            ? await createAltklausur({ variables: { input } })
            : await updateAltklausur({
                variables: { id: item.id || altMetaModal5.item?.id, input },
              });

        const savedId =
          result?.data?.createAltklausur?.id || result?.data?.updateAltklausur?.id;
        if (savedId) {
          const altForVersion = {
            ...(currentAlt || {}),
            id: savedId,
            title: item.title,
            description: item.description || "",
            isPublished: !!item.isPublished,
          };
          const versionInput = buildInternalAltVersionInput5(altForVersion, existingVersion);
          const versionResult = existingVersion?.id
            ? await updateAltklausurVersion({
                variables: { id: existingVersion.id, input: versionInput },
              })
            : await createAltklausurVersion({ variables: { input: versionInput } });
          const savedVersionId =
            versionResult?.data?.createAltklausurVersion?.id ||
            versionResult?.data?.updateAltklausurVersion?.id ||
            existingVersion?.id;
          setAltSelectedId5(savedId);
          if (savedVersionId) setAltSelectedVersionId5(savedVersionId);
        }
      }

      await refetchAlt5();
      setAltMetaModal5({ open: false, kind: "exam", mode: "create", item: null });
    } catch (error) {
      setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Altklausur konnte nicht gespeichert werden.");
      await refetchAlt5();
    } finally {
      setAltSaving5(false);
    }
  };

  const ensureSingleAltVersion5 = async (alt = selectedAltklausur5) => {
    if (!alt?.id) {
      throw new Error("Bitte wähle zuerst eine Altklausur aus.");
    }

    const existingVersion = getPrimaryAltVersion5(alt);
    if (existingVersion?.id) {
      setAltSelectedVersionId5(existingVersion.id);
      return existingVersion;
    }

    setAltSaving5(true);
    setAltError5("");
    try {
      const result = await createAltklausurVersion({
        variables: { input: buildInternalAltVersionInput5(alt) },
      });
      const created = result?.data?.createAltklausurVersion;
      if (!created?.id) {
        throw new Error("Altklausur-Inhalte konnten nicht vorbereitet werden.");
      }

      setAltSelectedVersionId5(created.id);
      await refetchAlt5();
      return created;
    } catch (error) {
      setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Altklausur-Inhalte konnten nicht vorbereitet werden.");
      await refetchAlt5();
      return null;
    } finally {
      setAltSaving5(false);
    }
  };

  const openAltContentEditor5 = (alt) => {
    guardIfDirtyOrRun(async () => {
      if (!alt?.id) return;
      setAltSelectedId5(alt.id);
      setAltContentEditingId5(alt.id);
      setAltEditorTab5("aufgaben");
      setOpenMenu5(null);
      setAltError5("");
      await ensureSingleAltVersion5(alt);
    });
  };

  const closeAltContentEditor5 = () => {
    guardIfDirtyOrRun(() => {
      setAltContentEditingId5(null);
      setOpenMenu5(null);
      setAltError5("");
    });
  };

  const swapAltQuestions5 = async (indexA, indexB) => {
    guardIfDirtyOrRun(async () => {
      if (selectedAltVersion5?.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      const list = selectedAltQuestions5;
      if (indexA < 0 || indexB < 0) return;
      if (indexA >= list.length || indexB >= list.length) return;

      const a = list[indexA];
      const b = list[indexB];
      if (!a?.id || !b?.id) return;

      setAltError5("");
      try {
        await updateAltklausurQuizQuestion({
          variables: { input: { id: a.id, position: b.position ?? 0 } },
        });
        await updateAltklausurQuizQuestion({
          variables: { input: { id: b.id, position: a.position ?? 0 } },
        });
        await refetchAlt5();
      } catch (error) {
        setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Quiz-Reihenfolge konnte nicht gespeichert werden.");
        await refetchAlt5();
      }
    });
  };

  const swapAltTasks5 = async (indexA, indexB) => {
    guardIfDirtyOrRun(async () => {
      if (selectedAltVersion5?.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      const list = selectedAltTasks5;
      if (indexA < 0 || indexB < 0) return;
      if (indexA >= list.length || indexB >= list.length) return;

      const a = list[indexA];
      const b = list[indexB];
      if (!a?.id || !b?.id) return;

      setAltError5("");
      try {
        await updateAltklausurTask({
          variables: { input: { id: a.id, position: b.position ?? 0 } },
        });
        await updateAltklausurTask({
          variables: { input: { id: b.id, position: a.position ?? 0 } },
        });
        await refetchAlt5();
      } catch (error) {
        setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Aufgaben-Reihenfolge konnte nicht gespeichert werden.");
        await refetchAlt5();
      }
    });
  };

  const deleteAltQuestion5 = async (question) => {
    guardIfDirtyOrRun(async () => {
      if (!question?.id) return;
      if (selectedAltVersion5?.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setAltError5("");
      try {
        await deleteAltklausurQuizQuestion({ variables: { id: question.id } });
        await refetchAlt5();
      } catch (error) {
        setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Quizfrage konnte nicht gelöscht werden.");
        await refetchAlt5();
      }
    });
  };

  const deleteAltTask5 = async (task) => {
    guardIfDirtyOrRun(async () => {
      if (!task?.id) return;
      if (selectedAltVersion5?.isLocked) {
        setAltError5(altLockedMessage5);
        return;
      }
      setAltError5("");
      try {
        await deleteAltklausurTask({ variables: { id: task.id } });
        await refetchAlt5();
      } catch (error) {
        setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Aufgabe konnte nicht gelöscht werden.");
        await refetchAlt5();
      }
    });
  };

  const saveAltQuiz5 = async ({ mode, question, options, initialOptions }) => {
    if (!selectedAltVersion5?.id) return;
    if (selectedAltVersion5.isLocked) {
      setAltError5(altLockedMessage5);
      return;
    }

    setAltSaving5(true);
    setAltError5("");
    try {
      const questionType = normalizeQuizType5(question.questionType);
      const firstCorrectIndex = options.findIndex((opt) => opt.isCorrect);
      const normalizedOptions = options.map((opt, index) => ({
        ...opt,
        isCorrect:
          questionType === "single_choice"
            ? index === Math.max(firstCorrectIndex, 0)
            : !!opt.isCorrect,
        position: index,
      }));

      let questionId = question.id;
      const position =
        mode === "create" ? maxPosPlusOne(selectedAltQuestions5) : question.position ?? 0;
      const fallbackQuestionSourceType = isWeeklyProfessorQuizSubject(subjectId)
        ? "professor"
        : "tutor";
      const questionSourceType =
        mode === "create" && isWeeklyProfessorQuizSubject(subjectId)
          ? "professor"
          : normalizeAltklausurQuizSourceType5(
              question.sourceType,
              fallbackQuestionSourceType
            );

      if (mode === "create") {
        const created = await createAltklausurQuizQuestion({
          variables: {
            input: {
              altklausurVersionID: selectedAltVersion5.id,
              position,
              questionText: question.questionText,
              questionType,
              explanation: question.explanation || "",
              hint: question.hint || "",
              points: Math.max(1, Number(question.points || 1)),
              sourceType: questionSourceType,
            },
          },
        });
        questionId = created?.data?.createAltklausurQuizQuestion?.id;
      } else {
        await updateAltklausurQuizQuestion({
          variables: {
            input: buildAltklausurQuestionInput5(
              {
                ...question,
                questionType,
                points: Math.max(1, Number(question.points || 1)),
                sourceType: questionSourceType,
              },
              position
            ),
          },
        });
      }

      if (!questionId) throw new Error("Quizfrage konnte nicht gespeichert werden.");

      const initialById = new Map(
        (initialOptions || []).filter((opt) => opt.id).map((opt) => [opt.id, opt])
      );
      const nextIds = new Set();

      for (let i = 0; i < normalizedOptions.length; i += 1) {
        const opt = normalizedOptions[i];
        if (opt.id) {
          nextIds.add(opt.id);
          // eslint-disable-next-line no-await-in-loop
          await updateAltklausurQuizOption({
            variables: {
              input: {
                id: opt.id,
                optionText: opt.optionText,
                isCorrect: !!opt.isCorrect,
                position: i,
              },
            },
          });
        } else {
          // eslint-disable-next-line no-await-in-loop
          await createAltklausurQuizOption({
            variables: {
              input: {
                questionID: questionId,
                optionText: opt.optionText,
                isCorrect: !!opt.isCorrect,
                position: i,
              },
            },
          });
        }
      }

      for (const id of initialById.keys()) {
        if (nextIds.has(id)) continue;
        // eslint-disable-next-line no-await-in-loop
        await deleteAltklausurQuizOption({ variables: { id } });
      }

      await refetchAlt5();
      setAltQuizModal5({ open: false, mode: "create", question: null });
    } catch (error) {
      setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Quizfrage konnte nicht gespeichert werden.");
      await refetchAlt5();
    } finally {
      setAltSaving5(false);
    }
  };

  const saveAltTask5 = async ({ mode, task }) => {
    if (!selectedAltVersion5?.id) return;
    if (selectedAltVersion5.isLocked) {
      setAltError5(altLockedMessage5);
      return;
    }

    setAltSaving5(true);
    setAltError5("");
    try {
      if (mode === "create") {
        await createAltklausurTask({
          variables: {
            input: {
              altklausurVersionID: selectedAltVersion5.id,
              title: task.title,
              taskText: task.taskText || "",
              hintText: task.hintText || "",
              answerText: task.answerText || "",
              position: maxPosPlusOne(selectedAltTasks5),
              difficulty: normalizeDifficulty5(task.difficulty),
              estimatedMinutes: Math.max(0, Number(task.estimatedMinutes || 0)),
              isPublished: !!task.isPublished,
            },
          },
        });
      } else {
        await updateAltklausurTask({
          variables: {
            input: buildAltklausurTaskInput5(task, task.position ?? 0),
          },
        });
      }

      await refetchAlt5();
      setAltTaskModal5({ open: false, mode: "create", task: null });
    } catch (error) {
      setAltError5(error?.graphQLErrors?.[0]?.message || error?.message || "Aufgabe konnte nicht gespeichert werden.");
      await refetchAlt5();
    } finally {
      setAltSaving5(false);
    }
  };

  const FullWidthLine5 = ({ showPlus, onPlusClick, plusEnabled = true }) => {
    return (
      <div
        className={`tutorR-lineWrap5 ${showPlus ? "has-plus5" : ""}`}
        style={{ "--tutorLeftWidth5": `${leftWidth}px` }}
      >
        {!showPlus ? (
          <div className="tutorR-line5" />
        ) : (
          <>
            <div className="tutorR-lineSeg5 left5" />
            <button
              type="button"
              className={`tutorR-plusBtn5 ${plusEnabled ? "" : "disabled5"}`}
              onClick={(e) => {
                e.stopPropagation();
                if (!plusEnabled) return;
                onPlusClick?.();
              }}
              aria-label="Neu"
            >
              <img className="tutorR-plusIcon5" src={TutorNewIcon} alt="Neu" draggable="false" />
            </button>
            <div className="tutorR-lineSeg5 right5" />
          </>
        )}
      </div>
    );
  };

  const renderSubjectBlock = (b, idx, total) => {
    const id = `subject-${b.id}`;
    const isDotsVisible = hoverId5 === id || (openMenu5 && openMenu5.id === id);

    const canUp = idx > 0;
    const canDown = idx < total - 1;

    return (
      <div
        key={b.id}
        className="tutorR-itemWrap5"
        ref={(el) => {
          if (el) blockRefs5.current.set(b.id, el);
        }}
        onMouseEnter={() => showDots(id)}
        onMouseLeave={() => scheduleHideDots(id)}
      >
        <DotsButton5
          visible={isDotsVisible}
          isOpen={openMenu5?.id === id}
          onClick={() => {
            setChooserOpen5(false);
            setOpenMenu5((prev) => (prev?.id === id ? null : { kind: "subject", id }));
            showDots(id);
          }}
        />

        {openMenu5?.id === id && (
          <div className="tutorR-menuAnchor5">
            <Menu5
              variant="subject"
              canUp={canUp}
              canDown={canDown}
              onEdit={() => {
                setOpenMenu5(null);
                openEditorEditSubjectBlock6(b);
              }}
              onUp={async () => {
                await swapSubjectBlocks5(idx, idx - 1);
                setOpenMenu5(null);
              }}
              onDown={async () => {
                await swapSubjectBlocks5(idx, idx + 1);
                setOpenMenu5(null);
              }}
              onDelete={async () => {
                await deleteSubjectBlock5(b);
              }}
            />
          </div>
        )}

        <div
          className="subject-description tutorR-content5 lh-lessonContent lh-lessonContent-normalized"
          dangerouslySetInnerHTML={{ __html: b.html || "" }}
        />
      </div>
    );
  };

  const renderLessonContent = (c, idx, total) => {
    const id = `lesson-${c.id}`;
    const isDotsVisible = hoverId5 === id || (openMenu5 && openMenu5.id === id);

    const canUp = idx > 0;
    const canDown = idx < total - 1;

    return (
      <div
        key={c.id}
        className="tutorR-itemWrap5"
        ref={(el) => {
          if (el) contentRefs5.current.set(c.id, el);
        }}
        onMouseEnter={() => showDots(id)}
        onMouseLeave={() => scheduleHideDots(id)}
      >
        <DotsButton5
          visible={isDotsVisible}
          isOpen={openMenu5?.id === id}
          onClick={() => {
            setChooserOpen5(false);
            setOpenMenu5((prev) => (prev?.id === id ? null : { kind: "lesson", id }));
            showDots(id);
          }}
        />

        {openMenu5?.id === id && (
          <div className="tutorR-menuAnchor5">
            <Menu5
              variant="lesson"
              canUp={canUp}
              canDown={canDown}
              onEdit={() => {
                setOpenMenu5(null);
                // only text is editable with this editor now
                openEditorEditLessonText6(c);
              }}
              onUp={async () => {
                await swapLessonContents5(idx, idx - 1);
                setOpenMenu5(null);
              }}
              onDown={async () => {
                await swapLessonContents5(idx, idx + 1);
                setOpenMenu5(null);
              }}
              onDelete={async () => {
                await deleteLessonContent5(c);
              }}
              aiEnabled={!!c.aiEnabled}
              onToggleAI={async () => {
                await toggleAI5(c);
              }}
            />
          </div>
        )}

        <div
          className="lesson-content tutorR-content5 lh-lessonContent lh-lessonContent-normalized"
          dangerouslySetInnerHTML={{ __html: c.contentData || "" }}
        />
      </div>
    );
  };

  const renderQuizCard5 = (quiz, idx, total) => {
    const id = `quiz-${quiz.id}`;
    const isDotsVisible = hoverId5 === id || (openMenu5 && openMenu5.id === id);
    const canUp = idx > 0;
    const canDown = idx < total - 1;

    return (
      <article
        key={quiz.id}
        className="tutorR-practiceCard5"
        ref={(el) => {
          if (el) quizRefs5.current.set(quiz.id, el);
        }}
        onMouseEnter={() => showDots(id)}
        onMouseLeave={() => scheduleHideDots(id)}
      >
        <DotsButton5
          visible={isDotsVisible}
          isOpen={openMenu5?.id === id}
          onClick={() => {
            setChooserOpen5(false);
            setOpenMenu5((prev) => (prev?.id === id ? null : { kind: "quiz", id }));
            showDots(id);
          }}
        />

        {openMenu5?.id === id && (
          <div className="tutorR-menuAnchor5">
            <Menu5
              variant="quiz"
              canUp={canUp}
              canDown={canDown}
              onEdit={() => openQuizEdit5(quiz)}
              onUp={async () => {
                await swapQuizzes5(idx, idx - 1);
                setOpenMenu5(null);
              }}
              onDown={async () => {
                await swapQuizzes5(idx, idx + 1);
                setOpenMenu5(null);
              }}
              onDelete={async () => {
                await deleteQuiz5(quiz);
              }}
            />
          </div>
        )}

        <div className="tutorR-practiceMeta5">
          <span>Quiz</span>
          <span>{normalizeQuizType5(quiz.questionType) === "multiple_choice" ? "Multiple Choice" : "Single Choice"}</span>
          <span>{normalizeDifficulty5(quiz.difficulty)}</span>
          {quiz.requiredForCompletion !== false ? <span>Pflicht</span> : null}
          {quiz.isKlausurRelevant ? <span>Klausurrelevant</span> : null}
        </div>
        <div
          className="tutorR-quizQuestionPreview5 lh-lessonContent"
          dangerouslySetInnerHTML={{
            __html: normalizeRichHtmlForDisplay(quiz.question, "Unbenannte Quizfrage"),
          }}
        />
        {quiz.hint ? <p className="tutorR-practiceHint5">{quiz.hint}</p> : null}
        <QuizOptionSummary5 quizId={quiz.id} />
      </article>
    );
  };

  const renderTaskCard5 = (task, idx, total) => {
    const id = `task-${task.id}`;
    const isDotsVisible = hoverId5 === id || (openMenu5 && openMenu5.id === id);
    const canUp = idx > 0;
    const canDown = idx < total - 1;

    return (
      <article
        key={task.id}
        className="tutorR-practiceCard5 is-task5"
        ref={(el) => {
          if (el) taskRefs5.current.set(task.id, el);
        }}
        onMouseEnter={() => showDots(id)}
        onMouseLeave={() => scheduleHideDots(id)}
      >
        <DotsButton5
          visible={isDotsVisible}
          isOpen={openMenu5?.id === id}
          onClick={() => {
            setChooserOpen5(false);
            setOpenMenu5((prev) => (prev?.id === id ? null : { kind: "task", id }));
            showDots(id);
          }}
        />

        {openMenu5?.id === id && (
          <div className="tutorR-menuAnchor5">
            <Menu5
              variant="task"
              canUp={canUp}
              canDown={canDown}
              onEdit={() => openTaskEdit5(task)}
              onUp={async () => {
                await swapTasks5(idx, idx - 1);
                setOpenMenu5(null);
              }}
              onDown={async () => {
                await swapTasks5(idx, idx + 1);
                setOpenMenu5(null);
              }}
              onDelete={async () => {
                await deleteTask5(task);
              }}
            />
          </div>
        )}

        <div className="tutorR-practiceMeta5">
          <span>Aufgabe</span>
          <span>{normalizeDifficulty5(task.difficulty)}</span>
          {Number(task.estimatedMinutes) > 0 ? <span>{task.estimatedMinutes} min</span> : null}
          <span>{task.isPublished ? "Veröffentlicht" : "Entwurf"}</span>
        </div>
        <h3>{task.title || "Unbenannte Aufgabe"}</h3>
        <div
          className="tutorR-taskPreview5 lh-lessonContent lh-lessonContent-normalized"
          dangerouslySetInnerHTML={{ __html: task.taskText || "" }}
        />
      </article>
    );
  };

  const renderAltQuizCard5 = (question, idx, total) => {
    const id = `alt-quiz-${question.id}`;
    const isDotsVisible = hoverId5 === id || (openMenu5 && openMenu5.id === id);
    const canUp = idx > 0 && !selectedAltVersion5?.isLocked;
    const canDown = idx < total - 1 && !selectedAltVersion5?.isLocked;
    const options = (question.options || []).slice().sort(sortPos);
    const correctCount = options.filter((opt) => opt.isCorrect).length;

    return (
      <article
        key={question.id}
        className="tutorR-altContentCard5"
        ref={(el) => {
          if (el) altQuizRefs5.current.set(question.id, el);
        }}
        onMouseEnter={() => showDots(id)}
        onMouseLeave={() => scheduleHideDots(id)}
      >
        <DotsButton5
          visible={isDotsVisible}
          isOpen={openMenu5?.id === id}
          onClick={() => {
            setChooserOpen5(false);
            setOpenMenu5((prev) => (prev?.id === id ? null : { kind: "altQuiz", id }));
            showDots(id);
          }}
        />

        {openMenu5?.id === id && (
          <div className="tutorR-menuAnchor5">
            <Menu5
              variant="quiz"
              canUp={canUp}
              canDown={canDown}
              onEdit={() => openAltQuizEdit5(question)}
              onUp={async () => {
                await swapAltQuestions5(idx, idx - 1);
                setOpenMenu5(null);
              }}
              onDown={async () => {
                await swapAltQuestions5(idx, idx + 1);
                setOpenMenu5(null);
              }}
              onDelete={async () => {
                await deleteAltQuestion5(question);
                setOpenMenu5(null);
              }}
            />
          </div>
        )}

        <div className="tutorR-practiceMeta5">
          <span>Quiz</span>
          <span>{normalizeQuizType5(question.questionType) === "multiple_choice" ? "Multiple Choice" : "Single Choice"}</span>
          <span>{Math.max(1, Number(question.points || 1))} Punkte</span>
          <span>{options.length} Optionen</span>
          <span>{correctCount} korrekt</span>
        </div>
        <div
          className="tutorR-quizQuestionPreview5 lh-lessonContent"
          dangerouslySetInnerHTML={{
            __html: normalizeRichHtmlForDisplay(question.questionText, "Unbenannte Quizfrage"),
          }}
        />
        {question.hint ? <p className="tutorR-practiceHint5">{question.hint}</p> : null}
      </article>
    );
  };

  const renderAltTaskCard5 = (task, idx, total) => {
    const id = `alt-task-${task.id}`;
    const isDotsVisible = hoverId5 === id || (openMenu5 && openMenu5.id === id);
    const canUp = idx > 0 && !selectedAltVersion5?.isLocked;
    const canDown = idx < total - 1 && !selectedAltVersion5?.isLocked;

    return (
      <article
        key={task.id}
        className="tutorR-altContentCard5 is-task5"
        ref={(el) => {
          if (el) altTaskRefs5.current.set(task.id, el);
        }}
        onMouseEnter={() => showDots(id)}
        onMouseLeave={() => scheduleHideDots(id)}
      >
        <DotsButton5
          visible={isDotsVisible}
          isOpen={openMenu5?.id === id}
          onClick={() => {
            setChooserOpen5(false);
            setOpenMenu5((prev) => (prev?.id === id ? null : { kind: "altTask", id }));
            showDots(id);
          }}
        />

        {openMenu5?.id === id && (
          <div className="tutorR-menuAnchor5">
            <Menu5
              variant="task"
              canUp={canUp}
              canDown={canDown}
              onEdit={() => openAltTaskEdit5(task)}
              onUp={async () => {
                await swapAltTasks5(idx, idx - 1);
                setOpenMenu5(null);
              }}
              onDown={async () => {
                await swapAltTasks5(idx, idx + 1);
                setOpenMenu5(null);
              }}
              onDelete={async () => {
                await deleteAltTask5(task);
                setOpenMenu5(null);
              }}
            />
          </div>
        )}

        <div className="tutorR-practiceMeta5">
          <span>Aufgabe</span>
          <span>{normalizeDifficulty5(task.difficulty)}</span>
          {Number(task.estimatedMinutes) > 0 ? <span>{task.estimatedMinutes} min</span> : null}
          <span>{task.isPublished ? "Veröffentlicht" : "Entwurf"}</span>
        </div>
        <h3>{task.title || "Unbenannte Aufgabe"}</h3>
        <div
          className="tutorR-taskPreview5 lh-lessonContent lh-lessonContent-normalized"
          dangerouslySetInnerHTML={{ __html: task.taskText || "" }}
        />
      </article>
    );
  };

  const handleEditorSave6 = async (html) => {
    // subject detail blocks
    if (editorKind6 === "subjectBlock") {
      if (!subjectId) return false;

      if (editorMode6 === "create") {
        const createPositions = getCreateSubjectBlockPositions(localSubjectBlocks5);
        let createError = null;
        let created = false;

        for (let i = 0; i < createPositions.length; i += 1) {
          const position = createPositions[i];
          try {
            await createSubjectDetailBlock({
              variables: { input: { subjectId, position, html } },
            });
            created = true;
            break;
          } catch (e) {
            createError = e;
            const message = String(
              e?.graphQLErrors?.[0]?.message || e?.message || ""
            ).toLowerCase();
            const isPositionCompatError =
              message.includes("failed to store subject detail block") ||
              message.includes("subject detail block query failed") ||
              message.includes("position");
            const canRetry = i < createPositions.length - 1;
            if (!isPositionCompatError || !canRetry) {
              await refetchBlocks();
              return false;
            }
          }
        }

        if (!created) {
          await refetchBlocks();
          if (createError) return false;
        }
        await refetchBlocks();
      } else {
        if (!editorTargetId6) return false;

        try {
          await updateSubjectDetailBlock({
            variables: { input: { id: editorTargetId6, html } },
          });
          await refetchBlocks();
        } catch (e) {
          await refetchBlocks();
          return false;
        }
      }

      setEditorOpen6(false);
      setEditorDirty6(false);
      return true;
    }

    // lesson text content
    if (editorKind6 === "lessonText") {
      if (!lessonId) return false;

      if (editorMode6 === "create") {
        const nextPosition = maxPosPlusOne(localLessonContents5);

        try {
          await createLessonContent({
            variables: {
              input: {
                lessonId,
                contentType: "text",
                contentData: html,
                position: nextPosition,
                aiEnabled: false,
              },
            },
          });
          await refetchContents();
        } catch (e) {
          await refetchContents();
          return false;
        }
      } else {
        if (!editorTargetId6) return false;

        try {
          await updateLessonContent({
            variables: { input: { id: editorTargetId6, contentData: html } },
          });
          await refetchContents();
        } catch (e) {
          await refetchContents();
          return false;
        }
      }

      setEditorOpen6(false);
      setEditorDirty6(false);
      return true;
    }

    return false;
  };

  /* ---------------- RENDER ---------------- */

  const weeklyProfessorModalSlot5 =
    isWeeklyProfessorException5 && altQuizModal5.open
      ? getWeeklyProfessorQuizSlot(altQuizModal5.question?.id)
      : null;

  // editor modal + discard modal must be available on both views
  const EditorLayer = (
    <>
      <TextEditor
        open={editorOpen6}
        initialHtml={editorInitialHtml6}
        mode={editorMode6}
        title={
          editorKind6 === "subjectBlock"
            ? editorMode6 === "edit"
              ? "Subject-Block bearbeiten"
              : "Subject-Block erstellen"
            : editorMode6 === "edit"
            ? "Lesson Content bearbeiten"
            : "Lesson Content erstellen"
        }
        subtitle="Mit HTML-Ansicht, Formeln, Tabellen und freien Bildern."
        onDirtyChange={(d) => setEditorDirty6(!!d)}
        onSave={handleEditorSave6}
        onRequestClose={closeEditorRequest6}
      />

      <QuizEditorModal5
        open={quizModal5.open}
        mode={quizModal5.mode}
        quiz={quizModal5.quiz}
        saving={quizSaving5}
        onClose={() => setQuizModal5({ open: false, mode: "create", quiz: null })}
        onSave={saveQuiz5}
      />

      <TaskEditorModal5
        open={taskModal5.open}
        mode={taskModal5.mode}
        task={taskModal5.task}
        saving={taskSaving5}
        onClose={() => setTaskModal5({ open: false, mode: "create", task: null })}
        onSave={saveTask5}
      />

      <AltklausurMetaModal5
        open={altMetaModal5.open}
        mode={altMetaModal5.mode}
        item={altMetaModal5.item}
        saving={altSaving5}
        onClose={() =>
          setAltMetaModal5({ open: false, kind: "exam", mode: "create", item: null })
        }
        onSave={saveAltMeta5}
      />

      <AltklausurQuizEditorModal5
        open={altQuizModal5.open}
        mode={altQuizModal5.mode}
        question={altQuizModal5.question}
        saving={altSaving5}
        titleOverride={
          weeklyProfessorModalSlot5
            ? `${weeklyProfessorModalSlot5.tutorTitle} bearbeiten`
            : undefined
        }
        subtitleOverride={
          weeklyProfessorModalSlot5
            ? "Frage, Antwortoptionen und Erklärung für das Wochenquiz festlegen."
            : undefined
        }
        onClose={() => setAltQuizModal5({ open: false, mode: "create", question: null })}
        onSave={saveAltQuiz5}
      />

      <TaskEditorModal5
        open={altTaskModal5.open}
        mode={altTaskModal5.mode}
        task={altTaskModal5.task}
        saving={altSaving5}
        contextLabel="diese Altklausur"
        onClose={() => setAltTaskModal5({ open: false, mode: "create", task: null })}
        onSave={saveAltTask5}
      />

      <DiscardChangesModal6 open={discardModalOpen6} onYes={onDiscardYes6} onNo={onDiscardNo6} />
    </>
  );

  if (showAltKlausurenEditor) {
    if (isWeeklyProfessorException5) {
      const loadedWeeklyQuestions5 = weeklyProfessorQuestionSlots5.filter(
        ({ question }) => !!question
      ).length;
      const weeklyQuizLocked5 = !!weeklyProfessorVersion5?.isLocked;

      if (altLoading5) {
        return (
          <div className="tutorR-root5">
            <div className="subject-right-container">Wochenquiz wird geladen...</div>
            {EditorLayer}
          </div>
        );
      }

      return (
        <div className="tutorR-root5">
          <div
            className="tutorR-container5 subject-right-container tutorR-altEditor5 tutorR-weeklyEditor5"
            ref={contentRootRef5}
          >
            <header className="tutorR-weeklyHero5">
              <div>
                <span className="tutorR-altKicker5">Praxis-Modus</span>
                <h1>Wöchentliche Quizfragen</h1>
                <p>
                  Bearbeite die zwei vom Professor freigegebenen Quizfragen für diese
                  Woche und die Wiederholung der letzten Vorlesung.
                </p>
              </div>
              <div className="tutorR-weeklyHeroPills5" aria-label="Wochenquiz Status">
                <span>{loadedWeeklyQuestions5}/2 Quizfragen</span>
                <span>Vom Professor geprüft</span>
                {weeklyQuizLocked5 ? <span>Gesperrt</span> : null}
              </div>
            </header>

            {altLoadError5 ? (
              <div className="tutorR-practiceEmpty5 error5">
                Wochenquiz konnte nicht geladen werden.
              </div>
            ) : null}

            {altError5 ? <div className="tutorR-practiceEmpty5 error5">{altError5}</div> : null}

            {!weeklyProfessorVersion5 && !altLoadError5 ? (
              <section className="tutorR-altEmpty5">
                <span>Noch nicht bereit</span>
                <h2>Wochenquiz wurde noch nicht eingerichtet</h2>
                <p>
                  Sobald die zwei festen Quizfragen veröffentlicht sind, können sie hier
                  bearbeitet werden.
                </p>
              </section>
            ) : (
              <section className="tutorR-weeklyQuizGrid5" aria-label="Wochenquiz bearbeiten">
                {weeklyProfessorQuestionSlots5.map(({ slot, question }) => {
                  if (!question) {
                    return (
                      <article className="tutorR-weeklyQuizCard5 missing5" key={slot.id}>
                        <div className="tutorR-weeklyCardTop5">
                          <span>{slot.badge}</span>
                          <span>Fehlt</span>
                        </div>
                        <h2>{slot.tutorTitle}</h2>
                        <p>
                          Diese feste Quizfrage wurde noch nicht gefunden. Bitte prüfe die
                          gespeicherten Quizfragen für dieses Wochenquiz.
                        </p>
                      </article>
                    );
                  }

                  const options = (question.options || []).slice().sort(sortPos);
                  const correctCount = options.filter((option) => option.isCorrect).length;
                  const quizType =
                    normalizeQuizType5(question.questionType) === "multiple_choice"
                      ? "Multiple Choice"
                      : "Single Choice";

                  return (
                    <article className="tutorR-weeklyQuizCard5" key={question.id}>
                      <div className="tutorR-weeklyCardTop5">
                        <span>{slot.badge}</span>
                        <span>Vom Professor geprüft</span>
                        <span>{quizType}</span>
                      </div>
                      <div className="tutorR-weeklyCardBody5">
                        <p>{slot.subtitle}</p>
                        <h2>{slot.tutorTitle}</h2>
                        <div
                          className="tutorR-weeklyQuestionPreview5 lh-lessonContent"
                          dangerouslySetInnerHTML={{
                            __html: normalizeRichHtmlForDisplay(
                              question.questionText,
                              "Unbenannte Quizfrage"
                            ),
                          }}
                        />
                      </div>
                      <div className="tutorR-weeklyMeta5">
                        <span>{Math.max(1, Number(question.points || 1))} Punkte</span>
                        <span>{options.length} Optionen</span>
                        <span>{correctCount} korrekt</span>
                      </div>
                      {question.hint ? (
                        <p className="tutorR-practiceHint5">Hinweis: {question.hint}</p>
                      ) : null}
                      <button
                        type="button"
                        className="tutorR-primaryBtn5"
                        onClick={() => openWeeklyProfessorQuestionEdit5(question)}
                        disabled={weeklyQuizLocked5 || altSaving5}
                        title={weeklyQuizLocked5 ? altLockedMessage5 : undefined}
                      >
                        Quizfrage bearbeiten
                      </button>
                    </article>
                  );
                })}
              </section>
            )}

            <section className="tutorR-weeklyNote5">
              <strong>Feste Wochenstruktur</strong>
              <p>
                Es werden nur diese beiden geprüften Quizfragen angezeigt. Zusätzliche
                Fragen oder Aufgaben sind für dieses Wochenquiz bewusst ausgeblendet.
              </p>
            </section>
          </div>

          {EditorLayer}
        </div>
      );
    }

    const hasAltVersion = !!selectedAltVersion5?.id;
    const isLocked = !!selectedAltVersion5?.isLocked;
    const selectedAltTitle = selectedAltklausur5?.title || altKlausurenEditorTitle5;
    const totalItems = selectedAltQuestions5.length + selectedAltTasks5.length;

    if (altLoading5) {
      return (
        <div className="tutorR-root5">
          <div className="subject-right-container">{altKlausurenEditorTitle5} wird geladen...</div>
          {EditorLayer}
        </div>
      );
    }

    return (
      <div className="tutorR-root5">
        <div
          className="tutorR-container5 subject-right-container tutorR-altEditor5"
          ref={contentRootRef5}
        >
          <header className="tutorR-altHero5">
            <div>
              <span className="tutorR-altKicker5">Praxis-Modus</span>
              <h1>{altKlausurenEditorTitle5}</h1>
              <p>
                Verwalte Altklausuren, Aufgaben und Quizfragen für diesen Kurs.
              </p>
            </div>
            <button
              type="button"
              className="tutorR-primaryBtn5"
              onClick={() => openAltMetaCreate5("exam")}
            >
              + Altklausur hinzufügen
            </button>
          </header>

          {altLoadError5 ? (
            <div className="tutorR-practiceEmpty5 error5">
              Alt Klausuren konnten nicht geladen werden.
            </div>
          ) : null}

          {altError5 ? <div className="tutorR-practiceEmpty5 error5">{altError5}</div> : null}

          {altklausuren5.length === 0 && !altLoadError5 ? (
            <section className="tutorR-altEmpty5">
              <span>Keine Altklausuren</span>
              <h2>Starte mit der ersten Altklausur</h2>
              <p>
                Lege eine Altklausur an und füge anschließend Aufgaben oder Quizfragen hinzu.
              </p>
              <button
                type="button"
                className="tutorR-primaryBtn5"
                onClick={() => openAltMetaCreate5("exam")}
              >
                Altklausur erstellen
              </button>
            </section>
          ) : !altContentEditingId5 ? (
            <section className="tutorR-altOverview5" aria-label="Altklausuren verwalten">
              {altklausuren5.map((alt) => {
                const counts = getAltContentCounts5(alt);
                return (
                  <article className="tutorR-altOverviewCard5" key={alt.id}>
                    <div className="tutorR-altBadges5">
                      <span>{alt.isPublished ? "Veröffentlicht" : "Entwurf"}</span>
                      <span>{counts.tasks} Aufgaben</span>
                      <span>{counts.quizzes} Quizfragen</span>
                    </div>
                    <div className="tutorR-altOverviewBody5">
                      <h2>{alt.title || "Altklausur"}</h2>
                      {alt.description ? <p>{alt.description}</p> : null}
                    </div>
                    <div className="tutorR-altOverviewActions5">
                      <button
                        type="button"
                        className="tutorR-secondaryBtn5"
                        onClick={() => openAltMetaEdit5("exam", alt)}
                      >
                        Bearbeiten
                      </button>
                      <button
                        type="button"
                        className="tutorR-primaryBtn5"
                        onClick={() => openAltContentEditor5(alt)}
                        disabled={altSaving5}
                      >
                        Inhalt bearbeiten
                      </button>
                    </div>
                  </article>
                );
              })}
            </section>
          ) : (
            <main className="tutorR-altContentEditor5">
              {selectedAltklausur5 ? (
                <>
                  <button
                    type="button"
                    className="tutorR-altBackBtn5 tutorR-altBackBtnTop5"
                    onClick={closeAltContentEditor5}
                  >
                    Zurück zu allen Klausuren
                  </button>
                  <section className="tutorR-altTopCard5">
                    <div>
                      <div className="tutorR-altBadges5">
                        <span>{selectedAltklausur5.isPublished ? "Veröffentlicht" : "Entwurf"}</span>
                        <span>{selectedAltTasks5.length} Aufgaben</span>
                        <span>{selectedAltQuestions5.length} Quizfragen</span>
                        {isLocked ? <span>Gesperrt</span> : null}
                      </div>
                      <h2>{selectedAltTitle}</h2>
                      {selectedAltklausur5.description ? (
                        <p>{selectedAltklausur5.description}</p>
                      ) : null}
                    </div>
                    <div className="tutorR-altActions5">
                      <button
                        type="button"
                        className="tutorR-secondaryBtn5"
                        onClick={() => openAltMetaEdit5("exam", selectedAltklausur5)}
                      >
                        Bearbeiten
                      </button>
                    </div>
                  </section>

                  {hasAltVersion ? (
                    <>
                      <section className="tutorR-altToolbar5">
                        <div className="tutorR-altTabs5" role="tablist" aria-label="Altklausur Inhalte">
                          <button
                            type="button"
                            role="tab"
                            aria-selected={altEditorTab5 === "aufgaben"}
                            className={altEditorTab5 === "aufgaben" ? "active5" : ""}
                            onClick={() => setAltEditorTab5("aufgaben")}
                          >
                            Aufgaben
                          </button>
                          <button
                            type="button"
                            role="tab"
                            aria-selected={altEditorTab5 === "quiz"}
                            className={altEditorTab5 === "quiz" ? "active5" : ""}
                            onClick={() => setAltEditorTab5("quiz")}
                          >
                            Quizfragen
                          </button>
                        </div>
                        <div className="tutorR-altToolbarActions5">
                          <span>{totalItems} Inhalte</span>
                          {altEditorTab5 === "aufgaben" ? (
                            <button
                              type="button"
                              className="tutorR-primaryBtn5"
                              onClick={openAltTaskCreate5}
                              disabled={isLocked}
                              title={isLocked ? "Altklausur ist gesperrt" : undefined}
                            >
                              + Aufgabe hinzufügen
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="tutorR-primaryBtn5"
                              onClick={openAltQuizCreate5}
                              disabled={isLocked}
                              title={isLocked ? "Altklausur ist gesperrt" : undefined}
                            >
                              + Quiz hinzufügen
                            </button>
                          )}
                        </div>
                      </section>

                      {altEditorTab5 === "aufgaben" ? (
                        selectedAltTasks5.length > 0 ? (
                          <div className="tutorR-altContentList5">
                            {selectedAltTasks5.map((task, index) =>
                              renderAltTaskCard5(task, index, selectedAltTasks5.length)
                            )}
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="tutorR-altDashedCreate5"
                            onClick={openAltTaskCreate5}
                            disabled={isLocked}
                          >
                            <span>+</span>
                            <strong>Neue Aufgabe erstellen</strong>
                            <small>Aufgabentext, Hinweis und Musterlösung hinzufügen.</small>
                          </button>
                        )
                      ) : selectedAltQuestions5.length > 0 ? (
                        <div className="tutorR-altContentList5">
                          {selectedAltQuestions5.map((question, index) =>
                            renderAltQuizCard5(question, index, selectedAltQuestions5.length)
                          )}
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="tutorR-altDashedCreate5"
                          onClick={openAltQuizCreate5}
                          disabled={isLocked}
                        >
                          <span>+</span>
                          <strong>Neue Quizfrage erstellen</strong>
                          <small>Frage, Optionen und Punkte hinzufügen.</small>
                        </button>
                      )}
                    </>
                  ) : (
                    <section className="tutorR-altEmpty5 compact5">
                      <span>Noch keine Inhalte</span>
                      <h2>Inhalte vorbereiten</h2>
                      <p>Danach kannst du Aufgaben und Quizfragen zu dieser Altklausur hinzufügen.</p>
                      <button
                        type="button"
                        className="tutorR-primaryBtn5"
                        onClick={() => ensureSingleAltVersion5()}
                        disabled={altSaving5}
                      >
                        Inhalte vorbereiten
                      </button>
                    </section>
                  )}
                </>
              ) : null}
            </main>
          )}
        </div>

        {EditorLayer}
      </div>
    );
  }

  if (!lessonId) {
    if (!subjectId) return <div className="tutorR-root5" />;

    if (blocksLoading)
      return (
        <div className="tutorR-root5">
          <div className="subject-right-container">Loading…</div>
          {EditorLayer}
        </div>
      );
    if (blocksError)
      return (
        <div className="tutorR-root5">
          <div className="subject-right-container">Error loading subject.</div>
          {EditorLayer}
        </div>
      );

    const blocks = localSubjectBlocks5;

    return (
      <div className="tutorR-root5">
        <div className="tutorR-container5 subject-right-container" ref={contentRootRef5}>
          <h1 className="subject-title">{pageTitle}</h1>

          <FullWidthLine5 showPlus={false} />

          {blocks.map((b, i) => (
            <React.Fragment key={b.id}>
              {renderSubjectBlock(b, i, blocks.length)}
              {i < blocks.length - 1 && <FullWidthLine5 showPlus={false} />}
            </React.Fragment>
          ))}

          {/* ✅ Subject details: plus enabled -> opens editor create */}
          <FullWidthLine5 showPlus plusEnabled onPlusClick={openEditorCreateSubjectBlock6} />
        </div>

        {EditorLayer}
      </div>
    );
  }

  if (contentsLoading)
    return (
      <div className="tutorR-root5">
        <div className="subject-right-container">Loading…</div>
        {EditorLayer}
      </div>
    );
  if (contentsError)
    return (
      <div className="tutorR-root5">
        <div className="subject-right-container">Error loading lesson.</div>
        {EditorLayer}
      </div>
    );

  const contents = localLessonContents5;
  const quizzes = localLessonQuizzes5;
  const tasks = localLessonTasks5;

  return (
    <div className="tutorR-root5">
      <div className="tutorR-container5 subject-right-container" ref={contentRootRef5}>
        <h1 className="subject-title">{pageTitle}</h1>

        {contents.length > 0 && <FullWidthLine5 showPlus={false} />}

        {contents.map((c, i) => (
          <React.Fragment key={c.id}>
            {renderLessonContent(c, i, contents.length)}
            {i < contents.length - 1 && <FullWidthLine5 showPlus={false} />}
          </React.Fragment>
        ))}

        {contents.length === 0 ? (
          <div className="tutorR-emptyPlusWrap5">
            <div className="tutorR-emptyPlusAnchor5">
              <button
                type="button"
                className="tutorR-plusBtn5 big5"
                onClick={openEditorCreateLessonText6}
                aria-label="Neu"
              >
                <img className="tutorR-plusIcon5" src={TutorNewIcon} alt="Neu" draggable="false" />
              </button>

              <TypeChooser5
                open={false}
                onClose={() => setChooserOpen5(false)}
                placement="belowPlus"
                onPick={(type) => {
                  if (type === "text") openEditorCreateLessonText6();
                }}
              />
            </div>
          </div>
        ) : (
          <>
            <FullWidthLine5
              showPlus
              onPlusClick={openEditorCreateLessonText6}
            />
            <div className="tutorR-chooserBelowLine5">
              <TypeChooser5
                open={false}
                onClose={() => setChooserOpen5(false)}
                onPick={(type) => {
                  if (type === "text") openEditorCreateLessonText6();
                }}
              />
            </div>
          </>
        )}

        <section className="tutorR-practiceEditor5">
          <div className="tutorR-practiceHeader5">
            <div>
              <span>Quizfragen</span>
              <h2>Lektionsquiz</h2>
            </div>
            <button type="button" className="tutorR-primaryBtn5" onClick={openQuizCreate5}>
              + Quiz hinzufügen
            </button>
          </div>

          {quizzesLoading ? <p className="tutorR-practiceEmpty5">Quizfragen werden geladen...</p> : null}
          {quizzesError ? <p className="tutorR-practiceEmpty5 error5">Quizfragen konnten nicht geladen werden.</p> : null}
          {!quizzesLoading && !quizzesError && quizzes.length === 0 ? (
            <div className="tutorR-practiceEmpty5">Noch keine Quizfrage für diese Lektion.</div>
          ) : null}

          <div className="tutorR-practiceList5">
            {quizzes.map((quiz, index) => renderQuizCard5(quiz, index, quizzes.length))}
          </div>
        </section>

        <section className="tutorR-practiceEditor5">
          <div className="tutorR-practiceHeader5">
            <div>
              <span>Aufgaben</span>
              <h2>Übungsaufgaben</h2>
            </div>
            <button type="button" className="tutorR-primaryBtn5" onClick={openTaskCreate5}>
              + Aufgabe hinzufügen
            </button>
          </div>

          {tasksLoading ? <p className="tutorR-practiceEmpty5">Aufgaben werden geladen...</p> : null}
          {tasksError ? <p className="tutorR-practiceEmpty5 error5">Aufgaben konnten nicht geladen werden.</p> : null}
          {!tasksLoading && !tasksError && tasks.length === 0 ? (
            <div className="tutorR-practiceEmpty5">Noch keine Aufgabe für diese Lektion.</div>
          ) : null}

          <div className="tutorR-practiceList5">
            {tasks.map((task, index) => renderTaskCard5(task, index, tasks.length))}
          </div>
        </section>
      </div>

      {EditorLayer}
    </div>
  );
}
